<template>
  <div>
    <div
      class="goods-list"
      v-for="(item, index) in goodList"
      :key="index"
      @click="goDetail(item)"
    >
      <div class="goods-img">
        <img :src="item.image" alt="" />
      </div>
      <div class="goods-content">
        <div class="title line l-1">{{ item.store_name }}</div>
        <div class="intrduce line l-1">{{ item.store_info }}</div>
        <div class="money">
          <div class="money-left">
            <div class="mon-day">￥{{ item.price }}</div>
            <div class="mon-del">￥{{ item.ot_price }}</div>
            <div class="span" v-if="item.gains!=0">
              <img src="../assets/images/icon_up.png" alt="" v-if="item.gains==1" />
              <img src="../assets/images/icon_down.png" alt="" v-if="item.gains==2" />
              <div style="color:#D01112">{{item.gains_num}}%</div>
            </div>
          </div>
          <div class="go-shop">立即购买</div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="goodList">
        <div
            @click="goDetail(item)"
            v-for="(item, index) in goodList"
            :key="index"
            class="item acea-row row-between-wrapper"
        >
            <div class="pictrue">
                <img v-lazy="item.image" alt="img" class="image" />
                <span
                    class="pictrue_log pictrue_log_class"
                    v-if="item.activity && item.activity.type === '1'"
                    >秒杀</span
                >
                <span
                    class="pictrue_log pictrue_log_class"
                    v-if="item.activity && item.activity.type === '2'"
                    >砍价</span
                >
                <span
                    class="pictrue_log pictrue_log_class"
                    v-if="item.activity && item.activity.type === '3'"
                    >拼团</span
                >
            </div>
            <div class="underline">
                <div class="text">
                    <div class="line1">{{ item.store_name }}</div>
                    <div class="money font-color-red">
                        ￥<span class="num">{{ item.price }}</span>
                    </div>
                    <div class="vip-money acea-row row-middle">
                        <div
                            class="vip"
                            v-if="item.vip_price && item.vip_price > 0"
                        >
                            ￥{{ item.vip_price || 0
                            }}<img src="@assets/images/vip.png" class="image" />
                        </div>
                        <span class="num"
                            >已售{{ item.sales }}{{ item.unit_name }}</span
                        >
                    </div>
                </div>
            </div>
            <div
                class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
            ></div>
        </div>
    </div> -->
</template>
<script>
import { goShopDetail } from "@libs/order";
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    }
  }
};
</script>
<style scoped>
.goods-list {
  height: 242px;
  margin: 15px 11px auto 11px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}
.goods-list .goods-img {
  width: 100%;
  height: 150px;
}
.goods-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.goods-list .goods-content {
  width: 100%;
  height: 91px;
  padding: 0 15px;
  background-color: #ffffff;
}
.goods-list .goods-content .title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
  line-height: 34px;
}
.goods-list .goods-content .intrduce {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
}

.goods-list .goods-content .money {
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: space-between;
}
.goods-list .goods-content .money .money-left {
  display: flex;
  align-items: center;
}
.goods-list .goods-content .money .money-left .mon-day {
  font-size: 16px;
  font-weight: 600;
  color: #d01112;
}
.goods-list .goods-content .money .money-left .mon-del {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  padding-left: 10px;
  text-decoration: line-through;
}
.goods-list .goods-content .money .go-shop {
  width: 64px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d01112;
  border-radius: 13px;
  color: #ffffff;
  font-size: 12px;
}
.quality-recommend .title {
  background-color: #ffffff;
  height: auto;
}
.span{
  display: flex;
  align-items: center;
  margin-left:10px ;
}
.span img{
  width: 15px;
  height: 9px;
}
.span div{
  padding-left: 5px;
}
</style>
